<template>
  <li
    class="kt-menu__item"
    aria-haspopup="true"
    :class="{
      'kt-menu__item--submenu': menu.submenu,
      'kt-menu__item--active': activeMenu(menu),
    }"
    :data-ktmenu-submenu-toggle="submenuToggle(menu)"
  >
    <KTMenuItemText
      v-bind:menu="menu"
      v-if="!menu.disabled && temAcesso()"
    ></KTMenuItemText>
    <!-- <v-badge bordered color="success" icon="fas fa-star" overlap v-else title="Em Breve">
      <v-btn depressed disabled>
        <v-icon small>{{ menu.icon }}</v-icon>
        <span class="ml-2">{{ menu.title }}</span>
      </v-btn>
    </v-badge> -->
    <KTMenuSubmenu
      v-if="menu.submenu"
      v-bind:submenu="menu.submenu"
      v-bind:parentMenu="menu"
    ></KTMenuSubmenu>
  </li>
</template>

<script>
import KTMenuItemText from "@/views/theme/header/MenuItemText.vue";
import KTMenuSubmenu from "@/views/theme/header/MenuSubmenu.vue";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";

export default {
  name: "KTMenuItem",
  data() {
    return {
      permissoes: [],
    };
  },
  components: {
    KTMenuItemText,
    KTMenuSubmenu,
  },
  props: {
    menu: Object,
  },
  methods: {
    activeMenu(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some((conf) => {
        if (conf.submenu) {
          return this.activeMenu(conf.submenu);
        }
        if (conf.page) {
          // current path starts with this path string
          return this.$route.path === `/${conf.page}`;
        }
      });
    },
    /**
     * Get submenu toggle type
     * @param menu
     * @returns {string|*}
     */
    submenuToggle(menu) {
      if (menu.hasOwnProperty("toggle")) {
        return menu.toggle;
      }
      return "hover";
    },

    temAcesso() {
      return PermissoesService.verificarMultiploAcesso(
        this.menu.modulo,
        Permissoes.Visualizar
      );
    },
  },
};
</script>
